import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useWatch } from 'react-hook-form';

import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';
import { useGreenhouseForm } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider';
import { SubcommitteeActionsProps } from './SubcommitteeActions';

const SubcommitteeDeleteButton = ({ rowId }: SubcommitteeActionsProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, setValue, trigger } = useGreenhouseForm();

  const isNewDetails = typeof rowId === 'string';

  const { completedSection } = useWatch({
    name: 'climateChangeStructure',
  });

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const handleDelete = () => {
    const prevSubcommittee =
      getValues().climateChangeStructure?.subcommitteeResponsibility
        .subcommittees ?? [];

    const currentIndex = isNewDetails
      ? Number(rowId.replace('NEW-', '')) - 1
      : prevSubcommittee.findIndex((detail) => detail.id === rowId);

    const updatedSubcommittees = prevSubcommittee?.filter(
      (_, index) => index !== currentIndex
    );

    setValue(
      'climateChangeStructure.subcommitteeResponsibility.subcommittees',
      updatedSubcommittees
    );
    trigger();
    close();
  };

  return (
    <>
      <GridActionsCellItem
        key="delete"
        icon={<DeleteOutlineIcon style={{ fontSize: '16px' }} />}
        label="Delete"
        onClick={open}
        disabled={isCompletedTh || isCompletedEn}
      />
      <DeleteModal
        topic="กรรมการชุดย่อยที่มีบทบาทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ"
        opened={opened}
        close={close}
        confirm={handleDelete}
      />
    </>
  );
};

export default SubcommitteeDeleteButton;
